import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useStore } from "../contexts/StoreContext";
import { useLang } from "../i18n";
import { getProductsByIds } from "../lib/api";
import ProductCard from "../components/ProductCard";
import { Spinner } from "../components/Loaders";
import { OBI } from "../assets/obi";

const WishlistPage = () => {
  const { wishlist } = useStore();
  const { t } = useLang();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (wishlist.length === 0) {
      setProducts([]);
      return;
    }
    setLoading(true);
    getProductsByIds(wishlist)
      .then(setProducts)
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, [wishlist]);

  return (
    <div data-testid="wishlist-page" className="min-h-screen">
      <section className="bg-pink-200 border-b-4 border-slate-900 py-10 bg-dots">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center gap-4">
          <Heart className="w-10 h-10 text-pink-500" fill="#ec4899" strokeWidth={2.5} />
          <div>
            <h1 className="font-display font-bold text-4xl lg:text-5xl text-slate-900">
              {t("wishlist.title")}
            </h1>
            <p className="text-slate-700 mt-1">{wishlist.length} {t("catalog.results_count")}</p>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {loading ? (
          <Spinner />
        ) : wishlist.length === 0 ? (
          <div className="cartoon-card p-12 text-center max-w-xl mx-auto">
            <img src={OBI.empty} alt="OBI" className="w-48 h-48 mx-auto" />
            <h2 className="font-display font-bold text-3xl mt-4">{t("wishlist.empty")}</h2>
            <p className="text-slate-600 mt-2">{t("wishlist.empty_sub")}</p>
            <Link to="/catalog" className="cartoon-btn bg-yellow-300 mt-6 inline-flex">
              {t("nav.catalog")}
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 sm:gap-8">
            {products.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default WishlistPage;
